import { useState } from "react";
import { supabase } from "../supabaseClient";

const GOLD     = "#C9A96E";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
const BORDER   = "#E7E1D8";
const SOFT_BG  = "#F7F5F2";
const WHITE    = "#FFFFFF";

const inputStyle = {
  width: "100%", padding: "9px 11px",
  border: `1px solid ${BORDER}`, borderRadius: 7,
  fontSize: 13, color: INK, background: "#FAFAF8",
  boxSizing: "border-box", outline: "none",
};
const labelStyle = {
  display: "block", fontSize: 10, letterSpacing: "0.12em",
  textTransform: "uppercase", color: INK_SOFT, marginBottom: 4, fontWeight: 600,
};
const sectionTitle = {
  fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase",
  color: GOLD, marginBottom: 14, fontWeight: 700,
};
const card = {
  background: WHITE, border: `1px solid ${BORDER}`,
  borderRadius: 12, padding: "22px 24px", marginBottom: 16,
};

function genererCodeProjet(nomProjet) {
  const annee = new Date().getFullYear();
  const suffix = Math.floor(100 + Math.random() * 900);
  const slug = (nomProjet || "PRJ")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .substring(0, 4);
  return `YD-${annee}-${slug}-${suffix}`;
}

export default function SignatureProjectPage({ projectData, setProjectData, setActiveTab, cabinetId = null }) {
  const [sending,    setSending]    = useState(false);
  const [emailMsg,   setEmailMsg]   = useState({ text: "", type: "success" });
  const [ouverture,  setOuverture]  = useState(false);

  const {
    nomClient, nomProjet, adresseProjet,
    codeProjet,
    contratSigne, premierVersementEncaisse,
    codeProjetCree, dossierDocumentaireOuvert, journalFinancierOuvert,
  } = projectData;

  function updateField(field, value) {
    setProjectData(prev => ({ ...prev, [field]: value }));
  }

  const readyToOpen =
    contratSigne && premierVersementEncaisse &&
    codeProjetCree && dossierDocumentaireOuvert && journalFinancierOuvert;

  function handleGenererCode() {
    const code = genererCodeProjet(nomProjet);
    updateField("codeProjet", code);
    updateField("codeProjetCree", true);
  }

  async function handleOuvrirProjet() {
    if (!readyToOpen) return;
    if (!projectData.emailClient) {
      setEmailMsg({ text: "Email client manquant — vérifiez la fiche client.", type: "error" });
      return;
    }

    setSending(true);
    setEmailMsg({ text: "", type: "success" });

    const code = codeProjet || genererCodeProjet(nomProjet);
    if (!codeProjet) updateField("codeProjet", code);

    const subject = `YOMA DESIGN — Votre projet ${nomProjet || ""} est officiellement lancé `;
    const body = `Bonjour ${nomClient || ""},

Nous avons le plaisir de vous confirmer que votre projet ${nomProjet ? `"${nomProjet}"` : ""} est désormais officiellement ouvert.

Toutes les conditions préalables ont été réunies — contrat signé, premier versement enregistré, dossier constitué. Votre projet porte à présent le code de référence : ${code}.

À partir d'aujourd'hui, nous entrons dans la phase active : YOMA DESIGN coordonne, pilote et veille sur chaque étape de votre chantier, à vos côtés, jusqu'à la remise des clés.

Nous sommes honorés de votre confiance et mobilisés pour faire de ce projet une réalisation à la hauteur de vos ambitions.

Cordialement,

L'équipe YOMA DESIGN
contact@yoma.design
Marrakech, Maroc`;

    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/send-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session?.access_token}`,
          },
          body: JSON.stringify({ to: projectData.emailClient, subject, body }),
        }
      );
      const result = await res.json();
      if (result.success) {
        setEmailMsg({ text: `✓ Email envoyé à ${projectData.emailClient}`, type: "success" });
        setOuverture(true);
      } else {
        setEmailMsg({ text: "Erreur : " + (result.error || "inconnue"), type: "error" });
      }
    } catch (err) {
      setEmailMsg({ text: "Erreur réseau : " + err.message, type: "error" });
    }
    setSending(false);
  }

  const conditions = [
    { label: "Contrat signé",              field: "contratSigne",              val: contratSigne },
    { label: "Premier versement encaissé", field: "premierVersementEncaisse",  val: premierVersementEncaisse },
    { label: "Code projet créé",           field: "codeProjetCree",            val: codeProjetCree },
    { label: "Dossier documentaire ouvert",field: "dossierDocumentaireOuvert", val: dossierDocumentaireOuvert },
    { label: "Journal financier ouvert",   field: "journalFinancierOuvert",    val: journalFinancierOuvert },
  ];

  const nbValides = conditions.filter(c => c.val).length;

  if (cabinetId == null) {
    return <div style={{ padding: 24, textAlign: "center", color: INK_SOFT }}>Chargement...</div>;
  }

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", color: INK, maxWidth: 1100 }}><div style={{ marginBottom: 24 }}><div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 4 }}>
          Contractualisation — Étape finale
        </div><div style={{ fontSize: 24, fontWeight: 700 }}>Signature Projet</div><div style={{ fontSize: 13, color: INK_SOFT, marginTop: 3 }}>
          Validation des conditions d'ouverture effective du projet
        </div></div><div style={{ display: "grid", gridTemplateColumns: "1.1fr 0.9fr", gap: 20, alignItems: "start" }}><div>
          {/* Identification */}
          <div style={card}><div style={sectionTitle}>Identification</div><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}><div><label style={labelStyle}>Nom du client</label><input style={inputStyle} value={nomClient || ""} onChange={e => updateField("nomClient", e.target.value)} placeholder="M. Hassan El Amrani" /></div><div><label style={labelStyle}>Nom du projet</label><input style={inputStyle} value={nomProjet || ""} onChange={e => updateField("nomProjet", e.target.value)} placeholder="Villa Al Karam" /></div><div style={{ gridColumn: "1 / -1" }}><label style={labelStyle}>Code projet</label><div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10 }}><input style={{ ...inputStyle, fontWeight: 700, color: GOLD, letterSpacing: "0.08em" }}
                    value={codeProjet || ""}
                    onChange={e => updateField("codeProjet", e.target.value)}
                    placeholder="YD-2026-VILLA-042" /><button onClick={handleGenererCode}
                    style={{ padding: "9px 16px", background: GOLD, color: INK, border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
                     Générer
                  </button></div></div></div></div>

          {/* Conditions */}
          <div style={card}><div style={sectionTitle}>Conditions d'ouverture ({nbValides}/5)</div><div style={{ marginBottom: 12, height: 6, background: BORDER, borderRadius: 3, overflow: "hidden" }}><div style={{ height: "100%", width: `${(nbValides / 5) * 100}%`, background: nbValides === 5 ? "#1A7A44" : GOLD, borderRadius: 3, transition: "width 0.3s" }} /></div><div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {conditions.map(c => (
                <label key={c.field} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderRadius: 8, border: `1px solid ${c.val ? "#B7E1C1" : BORDER}`, background: c.val ? "#E8F6EF" : SOFT_BG, cursor: "pointer" }}><input type="checkbox" checked={!!c.val} onChange={e => updateField(c.field, e.target.checked)}
                    style={{ accentColor: "#1A7A44", width: 15, height: 15, flexShrink: 0 }} /><span style={{ fontSize: 13, fontWeight: c.val ? 600 : 400, color: c.val ? "#1A7A44" : INK_SOFT }}>
                    {c.val ? "✓" : "○"} {c.label}
                  </span></label>
              ))}
            </div></div></div><div>
          {/* État */}
          <div style={{ ...card, borderTop: `4px solid ${readyToOpen ? "#1A7A44" : "#C0392B"}` }}><div style={sectionTitle}>État du projet</div><div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
              {[
                { label: "Client",  val: nomClient },
                { label: "Projet",  val: nomProjet },
                { label: "Code",    val: codeProjet },
              ].map(r => (
                <div key={r.label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${BORDER}`, fontSize: 13 }}><span style={{ color: INK_SOFT }}>{r.label}</span><span style={{ fontWeight: 700, color: r.label === "Code" ? GOLD : INK }}>{r.val || "—"}</span></div>
              ))}
            </div><div style={{ padding: "12px 16px", borderRadius: 8, background: readyToOpen ? "#E8F6EF" : "#FDEDEC", borderLeft: `4px solid ${readyToOpen ? "#1A7A44" : "#C0392B"}`, fontSize: 13, fontWeight: 600, color: readyToOpen ? "#1A7A44" : "#C0392B", marginBottom: 16 }}>
              {readyToOpen
                ? "✓ Toutes les conditions sont réunies. Le projet peut être ouvert."
                : ` ${5 - nbValides} condition${5 - nbValides > 1 ? "s" : ""} manquante${5 - nbValides > 1 ? "s" : ""} avant ouverture.`}
            </div>

            {emailMsg.text && (
              <div style={{ marginBottom: 14, padding: "10px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: emailMsg.type === "error" ? "#FDEDEC" : "#E8F6EF", color: emailMsg.type === "error" ? "#C0392B" : "#1A7A44" }}>
                {emailMsg.text}
              </div>
            )}

            {readyToOpen && !ouverture && (
              <button onClick={handleOuvrirProjet} disabled={sending}
                style={{ width: "100%", padding: "13px 20px", background: sending ? "#ccc" : "#1A7A44", color: WHITE, border: "none", borderRadius: 9, fontSize: 14, fontWeight: 800, cursor: sending ? "not-allowed" : "pointer" }}>
                {sending ? " Ouverture en cours..." : " Ouvrir le projet & notifier le client"}
              </button>
            )}

            {ouverture && (
              <button onClick={() => typeof setActiveTab === "function" && setActiveTab("projets")}
                style={{ width: "100%", padding: "13px 20px", background: GOLD, color: INK, border: "none", borderRadius: 9, fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
                → Accéder au module Projet
              </button>
            )}
          </div>

          {/* Règle YOMA */}
          <div style={card}><div style={sectionTitle}>Règle YOMA</div>
            {[
              "Aucun démarrage avant signature du contrat.",
              "Aucun démarrage avant encaissement du premier versement.",
              "Le code projet est la référence unique du dossier.",
              "Le projet naît seulement quand les 5 conditions sont réunies.",
            ].map((r, i) => (
              <div key={i} style={{ fontSize: 12, color: INK_SOFT, padding: "7px 0", borderBottom: `1px solid ${BORDER}`, paddingLeft: 10, borderLeft: `2px solid ${GOLD}`, marginBottom: 6 }}>
                {r}
              </div>
            ))}
          </div></div></div></div>
  );
}
